import Dropdown from "rc-dropdown";
import React, { useState } from "react";
import DatePicker from "../../../../elements/datePicker/DatePicker";
import { DelayInput } from "react-delay-input/lib/Component";
import { DateToTimestamp, TimestampToDate } from "../../../../../utils/timestampToDate";
import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper,
  StyledShowFilterBtn
} from "../../../../elements/filter/styledFiter";
import DefaultButton from "../../../../styles/materialButtonStyle";
import { StyledDatepicker } from "../../../../styles/styledDatepicker";

const ClientFilter = ({ t, filterData, setFilterData }) => {

  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "itemsPerPage": filterData["itemsPerPage"] ?? null,
    "user.firstname": "",
    "user.lastname": "",
    "user.email": "",
    "user.nickname": "",
    "user.createDate[gte]": null,
    "user.createDate[lte]": null
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    setFilterData(DEFAULT_FILTER_DATA);
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
          <StyledFilterDropdownWrapper>
            <StyledFilterBlock actions>
              <StyledFilterGroup className="clear-btn">
                <DefaultButton
                  color="transparent"
                  onClick={handleClearFilter}
                >
                  {t("clientsList.filter.clearBtn")}
                </DefaultButton>
              </StyledFilterGroup>
              <StyledFilterGroup className="close-btn">
                <StyledFilterCloseBtn onClick={() => setVisible(false)} />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("clientsList.filter.filterBy")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock>
              <StyledFilterGroup>
                <label htmlFor="user.nickname">
                  {t("clientsList.filter.nickname")}
                </label>
                <DelayInput
                  id="user.nickname"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "user.nickname": event.target.value, page: 1 })}
                  name="user.nickname"
                  value={filterData["user.nickname"]}
                  type="text"
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <label htmlFor="user.firstname">
                  {t("clientsList.filter.firstname")}
                </label>
                <DelayInput
                  id="user.firstname"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "user.firstname": event.target.value, page: 1 })}
                  name="user.firstname"
                  value={filterData["user.firstname"]}
                  type="text"
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <label htmlFor="user.lastname">
                  {t("clientsList.filter.lastname")}
                </label>
                <DelayInput
                  id="user.lastname"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "user.lastname": event.target.value, page: 1 })}
                  name="user.lastname"
                  value={filterData["user.lastname"]}
                  type="text"
                />
              </StyledFilterGroup>
              <StyledFilterGroup>
                <label htmlFor="user.email">E-mail</label>
                <DelayInput
                  id="user.email"
                  delayTimeout={2000}
                  onChange={event => setFilterData({ ...filterData, "user.email": event.target.value, page: 1 })}
                  name="user.email"
                  value={filterData["user.email"]}
                  type="text"
                />
              </StyledFilterGroup>
            </StyledFilterBlock>
            <StyledFilterBlockTitle>
              {t("clientsList.filter.date")}:
            </StyledFilterBlockTitle>
            <StyledFilterBlock>
              <StyledDatepicker>
                <label htmlFor="dateFrom">
                  {t("clientsList.filter.dateFrom")}
                </label>
                <DatePicker
                  format="dd-MM-y"
                  id="dateFrom"
                  name="dateFrom"
                  className="date-input"
                  onChange={dateFrom => setFilterData({
                    ...filterData,
                    "user.createDate[gte]": DateToTimestamp(dateFrom),
                    page: 1
                  })}
                  value={TimestampToDate(filterData["user.createDate[gte]"])}
                />
              </StyledDatepicker>
              <StyledDatepicker>
                <label htmlFor="dateTo">
                  {t("clientsList.filter.dateTo")}
                </label>
                <DatePicker
                  format="dd-MM-y"
                  id="dateTo"
                  name="dateTo"
                  className="date-input"
                  onChange={dateTo => setFilterData({
                    ...filterData,
                    "user.createDate[lte]": DateToTimestamp(dateTo),
                    page: 1
                  })}
                  value={TimestampToDate(filterData["user.createDate[lte]"])}
                />
              </StyledDatepicker>
            </StyledFilterBlock>
          </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("clientsList.filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default ClientFilter;